import Index from '@/pages';
import { createBrowserHistory } from 'history';

export const routers = [
  {
    path: '/',
    name: 'Main',
    component: Index,
  },
];

export const browserHistory = createBrowserHistory();
